import Vue from 'vue'
import axios from 'axios'

const $ = kendo.jQuery
const ee = new Vue()
const url = {
  action: (action, controller) => `/api/config/${controller}/${action}`,
}

function createControls(
  clientId,
  ccyPairId,
  flowTypeId,
  invalidHedgePolicyDates,
  nbPeriods,
  minDate,
) {
  let $window = $('<div id="hedgePolicyDateWindow"></div>').appendTo(document.body),
    kendoWindow = $window
      .kendoWindow({
        orientation: 'vertical',
        width: '690px',
        visible: false,
        resizable: false,
        modal: true,
        height: '90px',
        title: 'Create new Hedge Policy Date',
        actions: ['Close'],
        close: function() {
          $window.remove()
        },
      })
      .data('kendoWindow')
  var html = '<div id="hedgePolicyDateToolbar" style="text-align:center;" class = "row"> </div>'

  $window.empty().append(html)
  $('#hedgePolicyDateToolbar')
    .css('width', '99.85%')
    .kendoToolBar({
      items: [
        {
          template: "<h5 style='font-weight:bold; padding-right:10px;'>HedgePolicy Date: </h5>",
        },
        {
          template: "<input id='hedgePolicyDatePicker'/>",
        },
        {
          template:
            "<h5 style='font-weight:bold; padding-right:10px; padding-left:4px;'>Number of Months: </h5>",
        },
        {
          template: "<input id='suggestedTotalPeriods' style='width: 50px;'> </>",
        },
        {
          template: "<span id='addHedgePolicyDateButton'> </span>",
        },
        {
          template: "<span id='cancelHedgePolicyDateButton'> </span>",
        },
      ],
    })

  function getDate(initDate) {
    var date = initDate
    while (invalidHedgePolicyDates.indexOf(kendo.toString(date, 'yyyy-MM-dd')) >= 0) {
      date = new Date(date.setDate(date.getDate() + 1))
    }

    return date
  }

  var hedgePolicyDatePicker = $('#hedgePolicyDatePicker')
    .kendoDatePicker({
      dates: invalidHedgePolicyDates, //passing the disabledDays array to the template
      disableDates: function(date) {
        let selectedDate = kendo.toString(date, 'yyyy-MM-dd')
        let dates = invalidHedgePolicyDates
        if (selectedDate && dates.indexOf(selectedDate) >= 0) {
          return true
        } else {
          return false
        }
      },
      format: 'yyyy-MM-dd',
      change: function() {
        if (this.options.dates.indexOf(kendo.toString(this.value(), 'yyyy-MM-dd')) >= 0) {
          this.value(null) //clear the selected value
        }
      },
      month: {
        // template for dates in month view
        content:
          '# if (data.dates.includes(kendo.toString(data.date,"yyyy-MM-dd"))) { #' +
          '<div class="disabledDay">#= data.value #</div>' +
          '# } else { #' +
          '#= data.value #' +
          '# } #',
      },
      open: function() {
        $('.disabledDay')
          .parent()
          .removeClass('k-link') //removing this class makes the day unselectable
        $('.disabledDay')
          .parent()
          .removeAttr('href') //this removes the hyperlink styling
      },
    })
    .data('kendoDatePicker')

  minDate = kendo.parseDate(minDate)
  hedgePolicyDatePicker.value(getDate(minDate))

  var suggestedTotalPeriodsNumericTextBox = $('#suggestedTotalPeriods')
    .kendoNumericTextBox({
      format: 'n0',
      min: 1,
      spinners: false,
      step: 0,
    })
    .data('kendoNumericTextBox')

  var total = nbPeriods == null ? 12 : nbPeriods < 1 ? 12 : nbPeriods
  suggestedTotalPeriodsNumericTextBox.value(total)

  $('#addHedgePolicyDateButton').kendoButton({
    icon: 'k-icon k-i-check-outline',
    click: function() {
      addHedgePolicyDate()
    },
  })

  $('#cancelHedgePolicyDateButton').kendoButton({
    icon: 'k-icon k-i-cancel',
    click: function() {
      kendoWindow.close()
    },
  })

  function addHedgePolicyDate() {
    var postUrl = url.action('createHedgePolicy', 'hedgePolicy')
    axios
      .post(postUrl, {
        clientId: clientId,
        ccyPairId: ccyPairId,
        flowTypeId: flowTypeId,
        numberOfMonths: suggestedTotalPeriodsNumericTextBox.value(),
        hedgePolicyDate: kendo.toString(hedgePolicyDatePicker.value(), 'yyyy-MM-dd'),
      })
      .then(function(response) {
        var result = response.data
        if (!result.Errors) {
          ee.$emit('save')
          kendoWindow.close()
        }
      })
  }

  kendoWindow.center().open()
  kendo.resize($('.k-widget'))
}

export default {
  openWindow: function(clientId, ccyPairId, flowTypeId, invalidHedgePolicyDates, nbPeriods) {
    axios
      .get(url.action('getLastDate', 'hedgePolicy'), {
        params: {
          clientId: clientId,
          ccyPairId: ccyPairId,
          flowTypeId: flowTypeId,
        },
      })
      .then(function(minDate) {
        createControls(
          clientId,
          ccyPairId,
          flowTypeId,
          invalidHedgePolicyDates,
          nbPeriods,
          minDate.data,
        )
      })
  },
  onSaveChanges: function(callback) {
    ee.$on('save', callback)
  },
}
